<div style="height: 570px;">
  <form [formGroup]="SettingsForm">
    <div class="mb-3">
      <div class="col-lg-10">
        <fieldset>
          <legend>Create Events On</legend>
          <p-multiSelect id="monitorEventOn" [filter]="false" styleClass="event-selector"
          [options]="EventOnMap" formControlName="EventOnValues"></p-multiSelect>
        </fieldset>
      </div>
    </div>
    <div class="mb-3">
      <div class="col-lg-10">
        <fieldset>
          <legend>Log Events</legend>
          <div>
            <input type="checkbox" [formControl]="LogEvents" />
            <span class="uv-checkbox-label">Record events in the event log</span>
          </div>
        </fieldset>
      </div>
    </div>
    <br />
    <div class="mb-3">
      <div class="col-lg-12" style="display: grid; grid-template-columns: 1.5fr 1fr; column-gap: 10px;">
        <div>
          <fieldset>
            <legend>Email Events</legend>
            @if (!IsEmailConfigured) {
              <div class="mb-3 row" style="width: 425px; margin-left: 0px; margin-right: 0px;">
                <div class="alert alert-danger" style="margin-bottom: 0px;">
                  <span>SMTP server settings must be specified in the Network Settings</span>
                </div>
                <br />
              </div>
            }
            <div>
              <input type="checkbox" [formControl]="EmailEvents" (change)="enableDisableControls()" />
              <span class="uv-checkbox-label">Send email notifications containing events</span>
            </div>
            <br />
            <div class="col-lg-3">
              <span>Recipient Addresses:</span>
              <input type="text" pInputText style="width: 400px;" [formControl]="EmailRecipients" />
            </div>
            <br />
            <div>
              <input type="checkbox" [formControl]="IncludeSystemRecipients"
                style="margin-top: 10px;" (change)="enableDisableControls()" />
                <span class="uv-checkbox-label" style="margin-right: 10px;">Include System Recipients</span>
                <input type="text" pInputText style="width: 400px;" [formControl]="SystemRecipients" />
              </div>
              <br />
              <div>
                <input type="checkbox" [formControl]="EmailEventsAsText" />
                <span class="uv-checkbox-label" style="margin-right: 10px;">Send Email As Text</span>
              </div>
              <br />
              <div>
                <input type="checkbox" [formControl]="EmailSeparateEvents" />
                <span class="uv-checkbox-label" style="margin-right: 10px;">Send Emails (per device)</span>
              </div>
            </fieldset>
          </div>
          <div>
            <fieldset>
              <legend>Slack Events</legend>
              <div>
                <input type="checkbox" [formControl]="SlackEvents" (change)="enableDisableControls()" />
                <span class="uv-checkbox-label">Send Slack notifications containing events</span>
              </div>
              <br />
              <span class="col-lg-2">Webhook URLs:</span>
              <div class="col-lg-3">
                <textarea [formControl]="SlackWebhooks" rows="5" cols="90" placeholder="Paste your URLs here"></textarea>
              </div>
              <div class="mb-3 row" style="margin-top: 15px;">
                <div style="padding-left: 15px;">
                  <button type="button" (click)="testSlack()" pButton icon="fa" label="Test Slack"
                    title="Test/Verify Slack connection" [disabled]="!enableTestSlackButton">
                  </button>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <br />
      <div class="mb-3">
      </div>
    </form>
  </div>
